export default __webpack_public_path__ + "static/media/customer support.226843cc.svg";